export default "__VITE_ASSET__lE3U2$bb__"